/**
 * Byte size of a fetched/cached response, shared between `sw.ts` (records it
 * once at download time) and `entities/downloaded-issue`'s storage
 * calculator (backfills it for entries written before this field existed --
 * see that module's own comment). `Content-Length` is preferred when present
 * -- it avoids reading the whole body just to size it -- falling back to a
 * `Blob` read otherwise (some CDNs omit the header, or serve it chunked).
 * Returns `undefined` rather than throwing on failure: losing one asset's
 * size only under-reports that one entry, never worth failing the caller
 * over.
 */
export async function responseByteSize(
	response: Response,
): Promise<number | undefined> {
	const contentLength = response.headers.get('content-length');
	if (contentLength) {
		const parsed = Number(contentLength);
		if (!Number.isNaN(parsed)) {
			return parsed;
		}
	}
	try {
		const blob = await response.blob();
		return blob.size;
	} catch {
		return undefined;
	}
}
